import { isObjectRecord } from "../typeGuards/isObjectRecord";
import type { ArsListingVariable } from "./interface";

/**
 * Type guard for ArsListing variable payloads.
 *
 * @param obj - Unknown value to validate
 * @returns True when value can be treated as ArsListingVariable
 */
export const isArsListingVariable = (obj: unknown): obj is ArsListingVariable => {
  // Check object
  if (!isObjectRecord(obj)) return false;

  // Check required properties
  if (typeof obj.id !== "string") return false;
  if (typeof obj.name !== "string") return false;
  if (typeof obj.dataType !== "string") return false;
  if (typeof obj.description !== "string") return false;
  if (typeof obj.datasetName !== "string") return false;
  if (obj.datasetName.trim() === "") return false;
  if (obj.name.trim() === "") return false;
  // Everything is good
  return true;
};
